import GlobalSearchItem from "@/components/GlobalSearchItem";
import VendorLink from "@/components/VendorLink";
import { GlobalSearchResultItem } from "@/types/GlobalSearch";

type Props = {
  index: number;
  title: string;
  searchQuery: string;
  data: GlobalSearchResultItem[];
  totalDocuments: number;
};

const GlobalSearchGroup = ({
  index,
  title,
  searchQuery,
  data,
  totalDocuments,
}: Props) => {
  const getViewAllLink = () => {
    switch (title) {
      case "Users":
        return `/customers?q=${searchQuery}`;
      case "Contracts":
        return `/contracts?q=${searchQuery}`;
      default:
        return undefined;
    }
  };

  return (
    <>
      {index > 0 && <div className="border-border w-full border-t" />}
      <div className="w-full">
        <div className="mb-2 px-1.5 pt-2 font-medium">
          {title}
          {getViewAllLink() && (
            <>
              {" "}
              -{" "}
              <VendorLink
                href={getViewAllLink()}
                className="text-primary font-normal"
              >
                View {totalDocuments && <>{totalDocuments} </>}results
              </VendorLink>
            </>
          )}
        </div>
        {data?.map((result: GlobalSearchResultItem) => (
          <GlobalSearchItem
            key={result.id || result.userId}
            title={title}
            result={result}
          />
        ))}
      </div>
    </>
  );
};

export default GlobalSearchGroup;
